<template>
  <div class="wrapper">
    <div class="columns is-tablet">
      <div class="column is-12-mobile is-9-tablet p-l-150-fullhd p-r-150-fullhd primary-content">
          <back-button class="mb-5"/>
          <h1 class="title-page is-size-5 is-size-4-desktop has-text-weight-bold mb-2">Frequently Asked Questions</h1>
          <div>(You can also chat with our <a class="has-text-underline" href="#" @click="chatBase">customer assistant bot</a> for any question on how Pickafund works or what it can do)</div>
          <b-collapse :open="index === parseInt(sectionId)" position="is-top" v-for="(i, index) in articles" :aria-id="'faq-'+ index" :key="index">
            <a slot="trigger" slot-scope="props" :class="'faq-' + index" :aria-controls="'faq-' + index">
              <h2 class="title-section">{{i.cat}}</h2>
              <b-icon
                v-tooltip="'Expand/Collapse'"
                :icon="props.open ? 'menu-down' : 'menu-up'">
              </b-icon>
            </a>
            <span v-for="x in i.art" :key="x.id">
            <h3 class="subtitle-section">{{x.title}}</h3>
              <vue-simple-markdown :source="x.description"/>
            </span>
          </b-collapse>

          <div v-if="isBannerMobile" class="column is-12-mobile is-3-tablet is-hidden-tablet mt-5">
            <div class="" >
              <div class="banner-on-top" ref="subRight">
                <AdsGoogle />
              </div>
            </div>
          </div>

          <div class="columns is-mobile">
                <div class="column is-12-tablet disclaimer">
                    <Disclaimer />
                </div>
            </div>

      </div>
      <div v-if="!isBannerMobile" class="column is-12-mobile is-3-tablet is-hidden-mobile" ref="subRight_before">
        <div class="" >
          <div class="banner-on-top" ref="subRight">
            <AdsGoogle />
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import axios from "axios";
import BackButton from '@/components/BackButton.vue';
import commonMixin from "@/mixins/commonMixin";
import bannerMixin from "@/mixins/bannerMixin";
import Disclaimer from "@/components/Disclaimer"
import AdsGoogle from '@/components/AdsGoogle.vue';
export default {
  components: { BackButton, Disclaimer, AdsGoogle },
  mixins: [commonMixin, bannerMixin],
    data() {
        return {
            articles : [],
            sectionId: this.$route.query.id || '',
        }
    },
    methods: {
        chatBase(){
          document.querySelector('#chatbase-bubble-button').click();
        },
        async getdata() {
            await axios
                .get('/api/getfaq')
                .then(response => {
                   this.articles = response.data;
                })
                .catch((error) => alert(error))
            if (this.$route.query.id) {
                let headerHeight = document.querySelector('.navbar-brand').clientHeight + 20;
                let pageOffsetTop = document.querySelector('.faq-' + this.$route.query.id).offsetTop;
                let offsetTop = pageOffsetTop - headerHeight;
                window.scrollTo({
                    top: offsetTop,
                    behavior: "smooth",
                });
            }
        }
    },
    mounted() {
        this.getdata();
    },
    metaInfo() {
        return {
            title: "FAQs | Pickafund",
            meta: [
              { name: 'description', content:  'All you need to know in order to use Pickafund to its full potential'},
              { property: 'og:title', content: "FAQs | Pickafund"},
            ]
        }
    },
    created() {
      window.addEventListener('scroll', this.handleScroll);
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.handleScroll);
    },
}
</script>
